import { useLocation } from "react-router-dom";

export const useGetTenantId = () => {
  const { pathname } = useLocation();
  return {
    tenantId: pathname.replace("/tenant/", "").split("/")[0] || "root",
    isSDKPreview: pathname.includes("/smb-components"),
  };
};
